module.exports = __webpack_public_path__ + "img/Weapon_168.aa899f10.png";